var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8501 10.5H5.25126L4.74243 9.09993H9.80007V7.69986H4.23318L3.49986 5.68344V1.05C3.49986 0.4704 3.0303 0 2.44986 0H1.05C0.4704 0 0 0.46956 0 1.05V6.3L2.80014 14.0001V16.8H4.2V14.0001H8.4V16.8H9.80007V14.0001H10.8501C11.8167 14.0001 12.6 13.2168 12.6 12.2499C12.6 11.2833 11.8167 10.5 10.8501 10.5Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatIcon);
export default __webpack_public_path__ + "static/media/SeatIcon.03013b76cc8bc057dabe3aa69329845d.svg";
export { ForwardRef as ReactComponent };